import { useMemo } from 'react';
import { useQuery, QueryOptions } from 'react-query';
import ResidentService from '../../services/residentService';
import useAbortController from '../../hooks/useAbortController';
import { isValidResidentId } from '../../utils/resident-helpers';

const useResidentQuery = ({
  organizationId,
  propertyId,
  residentId,
  options = {},
}: {
  organizationId: string,
  propertyId: string,
  residentId: string,
  options?: QueryOptions,
}) => {
  const residentService = useMemo(() => new ResidentService(), []);
  const abortControllerOptions = useAbortController();
  const queryKey = ['getResident', organizationId, propertyId, residentId];
  const enabled =
    isValidResidentId(residentId) &&
    Boolean(organizationId && propertyId) &&
    options.enabled !== false;

  return useQuery(
    queryKey,
    () =>
      residentService.getResident(
        organizationId,
        propertyId,
        residentId,
        abortControllerOptions,
      ),
    {
      ...options,
      enabled,
    },
  );
};

export default useResidentQuery;
